





import {Vue, Component, Emit, Prop} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {Artikal} from "@/services/BackendProxies";

@Component({})
export default class ArtikliEditor extends Vue {
    @Prop() value!: string;
    @Prop() data!: [];
    artikli: Artikal[] = [];

    loader = async (params, success, failure) => {
        const artikli = await dataProxy.vratiArtikalPoOpisu(params.data.term);
        success(artikli);
    };

    processResults(data: any[]) {
        this.artikli = data;
        return {
            results: data.map((x) => ({id: x.naziv, text: x.naziv}))
        }
    }

    @Emit('input') changed(value) {
        const artikal = this.artikli.find(x => x.naziv == value);
        this.grupaDelova(artikal.grupaDelovaId);
        this.vrstaOdrzavanja(artikal.vrstaOdrzavanjaId);
    }

    @Emit() grupaDelova(grupaDelova?: number) {}
    @Emit() vrstaOdrzavanja(vrstaOdrzavanja?: number) {}
}
